module.exports = __webpack_public_path__ + "static/site-1783527333127/img/asset_newsletter-sm-bg.21194b74.png";